import { Check, X, DollarSign } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";

export default function FiuuReturn() {
    const [searchParams] = useSearchParams();
    const status = searchParams.get("status") || searchParams.get("s");
    const amount = searchParams.get("amount") || searchParams.get("a");
    const eventId = searchParams.get("eventId") || searchParams.get("e");
    const { t } = useTranslation();

    const isSuccess = status === "success";

    // Format amount to 2 decimal places
    const formattedAmount = amount ? parseFloat(amount).toFixed(2) : null;

    return (
        <div className="w-full min-h-[calc(100vh-6.5rem)] flex-center bg-base-100">
            <div className="bg-base-100 border border-base-300 rounded-lg shadow-lg p-6 md:p-8 flex-center max-w-md gap-4 text-center">
                {/* Status Icon */}
                <div
                    className={`flex-center rounded-full p-3 text-white w-16 h-16 ${
                        isSuccess ? "bg-success" : "bg-error"
                    }`}
                >
                    {isSuccess ? (
                        <Check className="text-2xl font-bold" />
                    ) : (
                        <X className="text-2xl font-bold" />
                    )}
                </div>

                {/* Title */}
                <h1
                    className={`text-2xl font-bold ${
                        isSuccess ? "text-success" : "text-error"
                    }`}
                >
                    {isSuccess
                        ? t("fiuuReturn.paymentSuccessful")
                        : t("fiuuReturn.paymentFailed")}
                </h1>

                {/* Amount Display - Only show for successful payments */}
                {isSuccess && formattedAmount && (
                    <div className="bg-base-200 rounded-lg p-4 w-full">
                        <div className="flex items-center justify-center gap-2 text-base-content/70 mb-1">
                            <DollarSign className="w-4 h-4" />
                            <span className="text-sm font-medium">
                                {t("fiuuReturn.amountPaid")}
                            </span>
                        </div>
                        <div className="text-3xl font-bold text-base-content">
                            {t("fiuuReturn.currency")} {formattedAmount}
                        </div>
                    </div>
                )}

                {/* Messages */}
                <div className="space-y-3 text-base-content/70">
                    {isSuccess ? (
                        <>
                            <p className="text-sm leading-relaxed">
                                {t("fiuuReturn.successMessage")}
                            </p>
                            <p className="text-sm leading-relaxed">
                                {t("fiuuReturn.checkSpamMessage")}
                            </p>
                            <p className="text-sm leading-relaxed">
                                {t("fiuuReturn.contactMessage")}
                                <a
                                    href="mailto:malaysiafightleague@gmail.com"
                                    className="underline ml-1"
                                >
                                    malaysiafightleague@gmail.com
                                </a>
                            </p>
                            {!!eventId && (
                                <div className="pt-2">
                                    <Link
                                        to={`/event/${eventId}?openLiveStream=true`}
                                        className="btn btn-primary w-full"
                                    >
                                        {t("fiuuReturn.enterCodeOnEventPage")}
                                    </Link>
                                </div>
                            )}
                        </>
                    ) : (
                        <p className="text-sm leading-relaxed">
                            {t("fiuuReturn.failedMessage")}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}
